import React, { Fragment } from 'react'

import './styles.scss'

import backgroundImg from './img/background.jpg'
import shapeImg from './img/shape.png'
import arrowImg from './img/arrow.png'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSimplifiedName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro137">
      <div className="bp1-intro137desktop anima-word-break ">
        <img src={background || backgroundImg} className="bp1-mainbackground" />
        <div className="bp1-mask"></div>
        <div className="bp1-content-layout-container">
          <div className="bp1-content">
            <div className="bp1-ornamentbg">
              <img
                src={shapeImg}
                className="bp1-shape bp1-intro137-anima-animate-enter"
              />
            </div>
            <div className="bp1-names bp1-intro137-anima-animate-enter4">
              <div
                className="notranslate bp1-couplesimplifiednam1 bp1-intro137-anima-animate-enter3"
                style={{
                  top: !coupleSimplifiedName.groom ? '26px' : undefined,
                  left: !coupleSimplifiedName.groom ? '37px' : undefined,
                }}
              >
                {coupleSimplifiedName.bride}
              </div>
              <img
                src={arrowImg}
                className="bp1-shape2 bp1-intro137-anima-animate-enter2"
                style={{
                  display: !coupleSimplifiedName.groom ? 'none' : undefined,
                }}
              />
              {!!coupleSimplifiedName.groom && (
                <Fragment>
                  <div className="notranslate bp1-couplesimplifiednam bp1-intro137-anima-animate-enter1">
                    {coupleSimplifiedName.groom}
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        </div>
        <div className="bp1-button-layout-container">
          <div className="bp1-button">
            <div
              className="bp1-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp1-button1" onClick={onSkipIntro}>
              <div className="bp1-button2"></div>
              <div className="bp1-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="bp2-intro137mobile anima-word-break ">
        <img src={background || backgroundImg} className="bp2-mainbackground" />
        <div className="bp2-mask"></div>
        <div className="bp2-button-layout-container">
          <div className="bp2-button">
            <div
              className="bp2-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp2-button1" onClick={onSkipIntro}>
              <div className="bp2-button2"></div>
              <div className="bp2-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="bp2-content-layout-container">
          <div className="bp2-content">
            <div className="bp2-ornamentbg">
              <img
                src={shapeImg}
                className="bp2-shape bp2-intro137-anima-animate-enter"
              />
            </div>
            <div className="bp2-names bp2-intro137-anima-animate-enter4">
              <div
                className="notranslate bp2-couplesimplifiednam1 bp2-intro137-anima-animate-enter3"
                style={{
                  top: !coupleSimplifiedName.groom ? '30px' : undefined,
                  left: !coupleSimplifiedName.groom ? '38px' : undefined,
                }}
              >
                {coupleSimplifiedName.bride}
              </div>
              <img
                src={arrowImg}
                className="bp2-shape bp2-intro137-anima-animate-enter2"
                style={{
                  display: !coupleSimplifiedName.groom ? 'none' : undefined,
                }}
              />
              {!!coupleSimplifiedName.groom && (
                <Fragment>
                  <div className="notranslate bp2-couplesimplifiednam bp2-intro137-anima-animate-enter1">
                    {coupleSimplifiedName.groom}
                    <br />
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
